/*
 * Copyright (c) 2020. FINN Sp. z o.o.
 */

package pl.finn.forms.tw17

import io.kvision.navigo.Navigo
import io.kvision.routing.Routing
import pl.finn.forms.App
import pl.finn.forms.utils.stringProperty

fun Routing.tw17Routing(app: App): Navigo {

  return on("/tytul_wykonawczy7_nowy/:token", { params ->
    Tw17Model.nowy(stringProperty(params, "token"), app)
  }).on("/tytul_wykonawczy7_edycja/:token", { params ->
    Tw17Model.edycja(stringProperty(params, "token"), app)
  })
}
